import {EntityStateAdapter} from '@/store/base.store';
import {ChallengeModel} from '@/models/challenge.model';
import store from '@/store';
import {Action, Module} from 'vuex-module-decorators';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';


export const featureKey = 'challenges_in_progress';

// @ts-ignore
if (store.state.challenges_in_progress) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class ChallengesInProgressStoreModule extends EntityStateAdapter<ChallengeModel> {

  get challenges(): ChallengeModel[] {
    return super.entities;
  }

  get currentPage(): number {
    return super.currentPage;
  }

  get lastPage(): number {
    return super.lastPage;
  }

  get loading(): boolean {
    return super.loading;
  }

  get challengesByTag(): (tag: string) => ChallengeModel[] {
    return (tag: string) => this._entities.filter((v) => {
      return v.tags?.filter((t) => t.name == tag)
    })
  }


  get homeChallenges(): ChallengeModel[] {
    const challenges = this._entities;
    return challenges && challenges.filter(({id}: any) => id <= 2)
      .map((challenge: any) => ({
        ...challenge,
        frontBanner: challenge.id === 1 ? (
          require('@/assets/images/challenges/bg-operation-walk.jpeg')
        ) : (challenge.id === 2) && (
          require('@/assets/images/challenges/bg-sanitation.jpeg')
        ),
      }));
  }

  @Action({commit: 'upsertMany', rawError: true})
  async fetchAll(data: {
    page: number,
    tag?: string
  }): Promise<ChallengeModel[]> {
    this.updateLoading(true);
    const response = await new ChallengesApi()
      .getChallengesbyFilter('in_progress', data.page, data.tag)
      .pipe(take(1))
      .toPromise();

    this.context.commit('updateAllPageParams', response);
    return response.data
  }

  @Action({rawError: true})
  async getRelatedChallenges(id: number): Promise<ChallengeModel[]> {
    return this._entities.filter((challenge) => challenge.id !== id);
  }
}
